module.exports = "/images/8d498ff6959570e1684e07305a2c0f48.png";